;(function($, window, document){
    window.CustomSelect = Me.view.extend({
        options: {
        },

        initialize: function() {
            _.bindAll(this, 'addEvents', 'toggleState', 'selectValue','close', 'updateValueFromDependencies');
            var view = this;
            this.addEvents();

            setTimeout(function(){
                var elementClicked = false;
                view.$('li').each(function(index,value){
                    if(view.$('input[type="hidden"]').val() == $(value).attr('value')){
                        view.$el.trigger('click');
                        $(value).addClass('selected').trigger('click');
                        elementClicked = true;
                    }
                });
                if(!elementClicked){
                    Me.dispatch.emit('customSelect.changed', view, {element: view.$el})
                }

            },10);
        },
        addEvents: function(){
            this.$el.on('click', this.toggleState);
            this.$('li').on('click', this.selectValue);
            Me.dispatch.subscribe('customSelect.changed', this.updateValueFromDependencies)
        },
        toggleState: function(e){

            this.$el.toggleClass('open');

            if(this.$el.hasClass('open')){
                $('body').on('click', this.close);
                e.stopPropagation();
            }
        },
        selectValue: function(e){
            //remove the ''placeholder'' styling applied to 'default-value' elements
            this.$('.value').removeClass('default-value');

            if(this.$('.value').text() != $(e.currentTarget).text()){
                //take the selected choice's displayed value and apply it to the field
                this.$('.value').text($(e.currentTarget).text());
                this.$('input[type="hidden"]').val($(e.currentTarget).attr('value'));

                //change current selected element class to the new selected element
                this.$('li.selected').removeClass('selected');
                $(e.currentTarget).addClass('selected');

                Me.dispatch.emit('customSelect.changed', this, {element: this.$el});

            }
        },
        updateValueFromDependencies: function(e, params){

            //whenever a field (i.e: province) is dependent from another (i.e: country): lookup for the value of the dependency and display only the fields from this set of value
            if(this.$el.attr('data-dependency') && params.element[0].id == this.$el.attr('data-dependency')){
                //get the dependency's selected choice and use its data-dependency-id to display our fields with similar value
                var dependencyValue = $('.custom-select#'+this.$el.attr('data-dependency')).find('li.selected').attr('data-dependency-id');
                //updates available choices based on dependency's selected value
                this.$('li').each(function(index, value){
                    //display only fields with the same dependency-id than the triggered dependency's value
                    if($(value).attr('data-dependency-id') != dependencyValue){
                        $(value).addClass('hide');
                    }else{
                        $(value).removeClass('hide');
                    }
                });

                //if a previously selected value is not available based on the current dependency's value, reset to the placeholder
                if(this.$('li.selected').attr('data-dependency-id') != dependencyValue){
                    if( this.$('input[type="hidden"]').attr('pageReload') != 'true'){
                        this.$('li.selected').removeClass('selected');
                        this.$('.value').addClass('default-value').text(this.$('.value').attr('placeholder'));
                        this.$('input[type="hidden"]').val('');
                    }else{
                        this.$('input[type="hidden"]').attr('pageReload', false)
                    }
                }

            }
        },
        close: function(){
            this.$el.removeClass('open');
            $('body').off('click', this.close);
        }
    });
}(jQuery, window, document));
